<div class="{{ 'tab-selector tab-selector--' + tabSelectorStyle }}">
  @for (option of options | async; track option) {
    <a
      [routerLink]="option.routeOptions.link"
      [queryParams]="option.routeOptions.queryParams"
      [replaceUrl]="true"
      queryParamsHandling="merge"
      class="tab-selector__tab"
      [class.tab-selector__tab--selected]="option.value === (selectedValue | async)"
      [class.with-icon]="showIcons"
    >
      @if (showIcons && option.icon) {
        <ftr-icon [color]="option.icon.colour" [icon]="option.icon.icon" align="Bottom"></ftr-icon>
      }
      {{ option.label || option.value }}
    </a>
  }
</div>
